import { render, staticRenderFns } from "./FrontPageCustom.vue?vue&type=template&id=561d562c&"
import script from "./FrontPageCustom.vue?vue&type=script&lang=js&"
export * from "./FrontPageCustom.vue?vue&type=script&lang=js&"
import style0 from "./FrontPageCustom.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports